import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import { Col, Row, ToggleButton } from 'react-bootstrap';
import Flex from 'components/common/Flex';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ProductDetailsReferences = ({ article, setImgs, setBolq, selectedRef, setSelectedRef }) => {
 const [makeover, setMakeover] = useState(null);
 const { images, references } = article;

 const onChange = prop => {
  setMakeover(`${prop.ref}-${prop.name}`);
  setSelectedRef([...selectedRef.filter(e => e.ref !== prop.ref), prop]);
 };

 useEffect(() => {
  if (makeover) {
   const [ref, name] = makeover.split('-');
   const properties = references.find(e => e.reference === ref)?.properties;
   const imgs = properties.find(e => e.name === name)?.images ?? [];
   if (imgs.length) setImgs(imgs);
   else if (properties.some(e => e.images.length)) setImgs(images);
  }
 }, [makeover]);

 useEffect(() => {
  if (!references.some(e => !selectedRef.some(a => a.ref === e.reference))) setBolq(false);
 }, [selectedRef]);

 return references.map((e, i) => (
  <Row className="g-2" key={i}>
   <Col md={2} className="fs--1 text-capitalize">
    {e.reference.toLowerCase()}
   </Col>
   <SimpleBarReact className="col-md-10 m-0" forceVisible="x" autoHide={true} style={{ whiteSpace: 'nowrap', overflowX: 'auto' }}>
    <Flex className="mb-2 mx-1 mt-1">
     {e.properties.map((prop, i) => (
      <ToggleButton
       key={i}
       size="sm"
       type="radio"
       id={prop._id}
       value={prop.name}
       name={e.reference}
       className="me-1 mb-0"
       variant="falcon-default"
       checked={selectedRef.some(e => e.name === prop.name)}
       onChange={() => onChange({ ...prop, ref: e.reference })}
      >
       <Flex alignItems="center" wrap="nowrap" justifyContent="center">
        {prop.color ? <FontAwesomeIcon icon="circle" className="" transform="shrink-3" style={{ color: prop.color }} /> : <></>}
        <span className="">{prop.name.toLowerCase()}</span>
       </Flex>
      </ToggleButton>
     ))}
    </Flex>
   </SimpleBarReact>
  </Row>
 ));
};

ProductDetailsReferences.propTypes = {
 article: PropTypes.shape({
  images: PropTypes.array,
  references: PropTypes.arrayOf(
   PropTypes.shape({
    reference: PropTypes.string.isRequired,
    properties: PropTypes.arrayOf(
     PropTypes.shape({ name: PropTypes.string.isRequired, color: PropTypes.string, images: PropTypes.array })
    ).isRequired
   })
  )
 }).isRequired,
 setImgs: PropTypes.func.isRequired,
 setBolq: PropTypes.func.isRequired,
 selectedRef: PropTypes.array.isRequired,
 setSelectedRef: PropTypes.func.isRequired
};

export default ProductDetailsReferences;
